import React from 'react';


import LockIcon from './icons/LockIcon';
import EPTierLock from './EPTierLock';
import { EPTierLockCoverContainer } from './styled';

export type EPTierLockCoverProps = {
  label: string;
  message?: string;
  tooltipTitle?: string | React.ReactElement;
  tooltipPlacement?: string;
  tooltipWidth?: number;
  tooltipTextPart1?: string | React.ReactElement;
  tooltipTextPart2?: string | React.ReactElement;
  tooltipClickableText?: string;
  emailRequestTypeOfInterestedPackage?: string;
  emailRequestButtonClicked?: string;
  emailRequestWhichScreen?: string;
  customMessage?: string;
  shouldShowTooltip?: boolean;
  disabledClick?: boolean;
  onClickHandler?: () => void;
};

// need to add 'position: relative;' to the parent of this component

const EPTierLockCover = ({
  message,
  label,
  tooltipTitle,
  tooltipTextPart1,
  tooltipTextPart2,
  tooltipClickableText,
  tooltipPlacement,
  tooltipWidth,
  emailRequestTypeOfInterestedPackage,
  emailRequestButtonClicked,
  emailRequestWhichScreen,
  customMessage,
  shouldShowTooltip,
  disabledClick = false,
  onClickHandler,
}: EPTierLockCoverProps) => (
  <EPTierLockCoverContainer>
    <div className="low-opacity-cover" />
    <div className="tier-lock">
      <EPTierLock
        label={label}
        tooltipTitle={tooltipTitle}
        tooltipTextPart1={tooltipTextPart1}
        tooltipTextPart2={tooltipTextPart2}
        tooltipClickableText={tooltipClickableText}
        tooltipPlacement={tooltipPlacement}
        tooltipWidth={tooltipWidth}
        icon={<LockIcon />}
        emailRequestTypeOfInterestedPackage={emailRequestTypeOfInterestedPackage}
        emailRequestButtonClicked={emailRequestButtonClicked}
        emailRequestWhichScreen={emailRequestWhichScreen}
        customMessage={customMessage}
        shouldShowTooltip={shouldShowTooltip}
        disabledClick={disabledClick}
        onClickHandler={onClickHandler}
      />
    </div>
    {message && <div className="background-data-label">{message}</div>}
  </EPTierLockCoverContainer>
);

export default EPTierLockCover;
